import PropTypes from 'prop-types'
import React from 'react'
import passwordStrength from 'bd-password-strength'
import styled from 'styled-components'

const strengthLevels = {
  none: {
    color: '#f43f55',
    percentage: 0,
  },
  poor: {
    color: '#f43f55',
    percentage: 25,
  },
  decent: {
    color: '#fbb84a',
    percentage: 50,
  },
  good: {
    color: '#007ae2',
    percentage: 75,
  },
  perfect: {
    color: '#7ed321',
    percentage: 100,
  },
}

const getStrengthLevel = strengthPercentage => {
  const keys = Object.keys(strengthLevels)
  return strengthLevels[
    keys.filter(key => strengthPercentage <= strengthLevels[key].percentage)[0]
  ]
}

const mapStrengthLevelToStyle = strengthLevel => ({
  backgroundColor: strengthLevel.color,
  width: `${strengthLevel.percentage}%`,
})

const PasswordStrengthMeter = ({ value, ...props }) => {
  const strength = passwordStrength.checkPassword(value)
  const strengthStyle = mapStrengthLevelToStyle(getStrengthLevel(strength))
  return <div {...props} style={strengthStyle} />
}

PasswordStrengthMeter.propTypes = {
  value: PropTypes.string.isRequired,
}

const StyledStrengthMeter = styled(PasswordStrengthMeter)`
  height: 100%;
  transition: all ${({ theme }) => theme.transitions.duration[1]};
`

export default StyledStrengthMeter
